import classNames from 'classnames';
import AIIcon from 'components/atoms/SVG/AIIcon';
import type { FC } from 'react';

const TypingLoader = () => {
  return (
    <div className="flex space-x-1 justify-center items-center ">
      <span className="sr-only">Loading...</span>
      <div className="h-2 w-2 bg-primary-300 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
      <div className="h-2 w-2 bg-primary-600 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
      <div className="h-2 w-2 bg-primary rounded-full animate-bounce"></div>
    </div>
  );
};

const AIChatSpinner: FC<{
  size?: 'small' | 'medium' | 'large';
  className?: string;
}> = ({ size = 'medium', className }) => {
  const containerSizesClasses = {
    small: 'w-6 h-6 p-[1px]',
    medium: 'w-8 h-8 p-[1px]',
    large: 'w-12 h-12 p-[1px]',
  };
  const iconSizesClasses = {
    small: 'w-[23px] h-[23px]',
    medium: 'w-[31px] h-[31px]',
    large: 'w-[47px] h-[47px]',
  };
  return (
    <div className={classNames('relative mt-1', className)}>
      <div
        style={{ transformOrigin: 'center center' }}
        className={classNames(
          'absolute top-0 left-0',
          'relative rounded-full flex items-stretch justify-center',
          ' ai-gradient animate-spin',
          containerSizesClasses[size],
        )}
      ></div>
      <div
        className={classNames(
          'absolute top-[0.5px] left-[0.5px]',
          'flex flex-1 items-center justify-center rounded-full bg-white',
        )}
      >
        <AIIcon
          stroke="#8059C8"
          className={classNames('', iconSizesClasses[size])}
        />
      </div>
    </div>
  );
};

export default AIChatSpinner;
